import React from 'react';
import renderHTML from 'react-render-html';
import PropTypes from 'prop-types';


export default class StaticPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      htmlContent: props.htmlContent
    };
  }

  static get propTypes() {
    return {
      url: PropTypes.string,
      htmlContent: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      htmlContent: ''
    };
  }

  componentDidMount() {
    const { htmlContent } = this.state;
    const { url } = this.props;

    if (!htmlContent && url) {
      fetch(url)
        .then((response) =>response.text())
        .then((htmlContent) => this.setState({ htmlContent }));
    }
  }

  render() {
    const { htmlContent } = this.state;
    return renderHTML(htmlContent);
  }
}


// WEBPACK FOOTER //
// src/components/shared/StaticPage/index.jsx